import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { CalendarIcon, UsersIcon, CreditCardIcon, ArrowRightIcon, ChevronRightIcon, CalendarCheckIcon } from 'lucide-react';
const DashboardScreen = () => {
  // Sample data for charts
  const dutyData = [{
    name: 'Week 1',
    assigned: 45,
    completed: 40
  }, {
    name: 'Week 2',
    assigned: 50,
    completed: 48
  }, {
    name: 'Week 3',
    assigned: 35,
    completed: 30
  }, {
    name: 'Week 4',
    assigned: 60,
    completed: 55
  }];
  const memberStatusData = [{
    name: 'Active',
    value: 120,
    color: '#15803d'
  }, {
    name: 'On Leave',
    value: 15,
    color: '#f59e0b'
  }, {
    name: 'Inactive',
    value: 5,
    color: '#dc2626'
  }];
  const upcomingEvents = [{
    id: 1,
    title: 'Ashara Mubaraka Security',
    date: '2023-08-15',
    location: 'Main Markaz',
    members: 25
  }, {
    id: 2,
    title: 'Eid-ul-Fitr Duty',
    date: '2023-08-18',
    location: 'Masjid Complex',
    members: 15
  }, {
    id: 3,
    title: 'Community Gathering',
    date: '2023-08-20',
    location: 'Community Hall',
    members: 10
  }];
  const recentLawajam = [{
    id: 1,
    member: 'Ahmed Ali',
    amount: 2500,
    date: '2023-08-10',
    status: 'Paid'
  }, {
    id: 2,
    member: 'Murtaza Husain',
    amount: 1500,
    date: '2023-08-09',
    status: 'Pending'
  }, {
    id: 3,
    member: 'Yusuf Najmuddin',
    amount: 3000,
    date: '2023-08-08',
    status: 'Paid'
  }, {
    id: 4,
    member: 'Taher Saifuddin',
    amount: 2000,
    date: '2023-08-07',
    status: 'Pending'
  }];
  return <div className="space-y-6" data-id="element-58">
      <div className="flex justify-between items-center" data-id="element-59">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-60">Dashboard</h1>
        <div className="text-sm text-gray-500" data-id="element-61">
          Last updated: August 15, 2023 at 10:30 AM
        </div>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-62">
        <div className="bg-white rounded-lg shadow p-6 flex items-center" data-id="element-63">
          <div className="rounded-full bg-blue-100 p-3 mr-4" data-id="element-64">
            <UsersIcon size={24} className="text-blue-800" data-id="element-65" />
          </div>
          <div data-id="element-66">
            <div className="text-sm font-medium text-gray-500" data-id="element-67">
              Total Members
            </div>
            <div className="text-2xl font-bold" data-id="element-68">140</div>
            <div className="text-xs text-green-600" data-id="element-69">+5 this month</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6 flex items-center" data-id="element-70">
          <div className="rounded-full bg-green-100 p-3 mr-4" data-id="element-71">
            <CalendarCheckIcon size={24} className="text-green-700" data-id="element-72" />
          </div>
          <div data-id="element-73">
            <div className="text-sm font-medium text-gray-500" data-id="element-74">
              Active Duties
            </div>
            <div className="text-2xl font-bold" data-id="element-75">28</div>
            <div className="text-xs text-blue-600" data-id="element-76">Next: Aug 15</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6 flex items-center" data-id="element-77">
          <div className="rounded-full bg-purple-100 p-3 mr-4" data-id="element-78">
            <CreditCardIcon size={24} className="text-purple-700" data-id="element-79" />
          </div>
          <div data-id="element-80">
            <div className="text-sm font-medium text-gray-500" data-id="element-81">
              Lawajam Collected
            </div>
            <div className="text-2xl font-bold" data-id="element-82">₹42,500</div>
            <div className="text-xs text-green-600" data-id="element-83">+₹12,500 this month</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6 flex items-center" data-id="element-84">
          <div className="rounded-full bg-amber-100 p-3 mr-4" data-id="element-85">
            <CalendarIcon size={24} className="text-amber-700" data-id="element-86" />
          </div>
          <div data-id="element-87">
            <div className="text-sm font-medium text-gray-500" data-id="element-88">
              Events This Month
            </div>
            <div className="text-2xl font-bold" data-id="element-89">6</div>
            <div className="text-xs text-gray-600" data-id="element-90">3 completed</div>
          </div>
        </div>
      </div>
      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-91">
        <div className="bg-white rounded-lg shadow p-6 lg:col-span-2" data-id="element-92">
          <div className="flex justify-between items-center mb-4" data-id="element-93">
            <h2 className="text-lg font-semibold text-gray-800" data-id="element-94">
              Duty Statistics
            </h2>
            <select className="border rounded px-2 py-1 text-sm" data-id="element-95">
              <option data-id="element-96">Last 4 Weeks</option>
              <option data-id="element-97">Last 3 Months</option>
              <option data-id="element-98">Last Year</option>
            </select>
          </div>
          <div className="h-80" data-id="element-99">
            <ResponsiveContainer width="100%" height="100%" data-id="element-100">
              <BarChart data={dutyData} margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-101">
                <CartesianGrid strokeDasharray="3 3" data-id="element-102" />
                <XAxis dataKey="name" data-id="element-103" />
                <YAxis data-id="element-104" />
                <Tooltip data-id="element-105" />
                <Legend data-id="element-106" />
                <Bar dataKey="assigned" fill="#1e40af" name="Assigned" data-id="element-107" />
                <Bar dataKey="completed" fill="#15803d" name="Completed" data-id="element-108" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-109">
          <div className="flex justify-between items-center mb-4" data-id="element-110">
            <h2 className="text-lg font-semibold text-gray-800" data-id="element-111">
              Member Status
            </h2>
          </div>
          <div className="h-80" data-id="element-112">
            <ResponsiveContainer width="100%" height="100%" data-id="element-113">
              <PieChart data-id="element-114">
                <Pie data={memberStatusData} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="value" label={({
                name,
                percent
              }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-115">
                  {memberStatusData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-116" />)}
                </Pie>
                <Tooltip data-id="element-117" />
                <Legend data-id="element-118" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      {/* Bottom Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-119">
        {/* Upcoming Events */}
        <div className="bg-white rounded-lg shadow" data-id="element-120">
          <div className="p-6 border-b" data-id="element-121">
            <div className="flex justify-between items-center" data-id="element-122">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-123">
                Upcoming Events
              </h2>
              <button className="text-blue-600 hover:text-blue-800 flex items-center text-sm" data-id="element-124">
                View All <ArrowRightIcon size={16} className="ml-1" data-id="element-125" />
              </button>
            </div>
          </div>
          <div className="divide-y" data-id="element-126">
            {upcomingEvents.map(event => <div key={event.id} className="p-4 hover:bg-gray-50" data-id="element-127">
                <div className="flex justify-between items-start" data-id="element-128">
                  <div data-id="element-129">
                    <h3 className="font-medium text-gray-800" data-id="element-130">{event.title}</h3>
                    <div className="text-sm text-gray-500 mt-1" data-id="element-131">
                      {event.location}
                    </div>
                    <div className="flex items-center mt-2 text-sm" data-id="element-132">
                      <CalendarIcon size={14} className="mr-1 text-gray-500" data-id="element-133" />
                      <span data-id="element-134">{event.date}</span>
                      <UsersIcon size={14} className="ml-3 mr-1 text-gray-500" data-id="element-135" />
                      <span data-id="element-136">{event.members} members assigned</span>
                    </div>
                  </div>
                  <button className="text-gray-400 hover:text-blue-600" data-id="element-137">
                    <ChevronRightIcon size={20} data-id="element-138" />
                  </button>
                </div>
              </div>)}
          </div>
        </div>
        {/* Recent Lawajam */}
        <div className="bg-white rounded-lg shadow" data-id="element-139">
          <div className="p-6 border-b" data-id="element-140">
            <div className="flex justify-between items-center" data-id="element-141">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-142">
                Recent Lawajam Activity
              </h2>
              <button className="text-blue-600 hover:text-blue-800 flex items-center text-sm" data-id="element-143">
                View All <ArrowRightIcon size={16} className="ml-1" data-id="element-144" />
              </button>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-145">
            <table className="w-full" data-id="element-146">
              <thead className="bg-gray-50" data-id="element-147">
                <tr data-id="element-148">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-149">
                    Member
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-150">
                    Amount
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-151">
                    Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-152">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-153">
                {recentLawajam.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-154">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" data-id="element-155">
                      {item.member}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" data-id="element-156">
                      ₹{item.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-157">
                      {item.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-158">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${item.status === 'Paid' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-159">
                        {item.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Quick Links */}
      <div className="bg-white rounded-lg shadow p-6" data-id="element-160">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-161">
          Quick Links
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-162">
          <button className="p-4 border rounded-lg hover:bg-gray-50 flex items-center justify-center" data-id="element-163">
            <UsersIcon size={20} className="mr-2 text-blue-800" data-id="element-164" />
            <span data-id="element-165">Add New Member</span>
          </button>
          <button className="p-4 border rounded-lg hover:bg-gray-50 flex items-center justify-center" data-id="element-166">
            <CalendarCheckIcon size={20} className="mr-2 text-green-700" data-id="element-167" />
            <span data-id="element-168">Create New Duty</span>
          </button>
          <button className="p-4 border rounded-lg hover:bg-gray-50 flex items-center justify-center" data-id="element-169">
            <CreditCardIcon size={20} className="mr-2 text-purple-700" data-id="element-170" />
            <span data-id="element-171">Record Lawajam</span>
          </button>
          <button className="p-4 border rounded-lg hover:bg-gray-50 flex items-center justify-center" data-id="element-172">
            <CalendarIcon size={20} className="mr-2 text-amber-700" data-id="element-173" />
            <span data-id="element-174">Schedule Event</span>
          </button>
        </div>
      </div>
    </div>;
};
export default DashboardScreen;